import { Link } from 'react-router-dom';
import { trackPhoneClick, trackLineClick } from '../../utils/tracking';

export default function ContactPage() {
  const contactInfo = {
    phone: '0978-900-081',
    email: 'sadiest018moving@gmail.com',
    address: '新北市泰山區福德街49號3樓',
    plusCode: '3C7J+FW 山腳里',
    hours: '週一至週日 8:00-20:00',
    serviceArea: '新北市、台北市、桃園市、新竹市',
    line: 'https://line.me/ti/p/@285yavdh',
    googleMaps: 'https://www.google.com/maps/search/建鈞精緻搬家+新北市泰山區福德街49號3樓'
  };

  const handlePhoneClick = () => {
    trackPhoneClick('0978-900-081');
  };

  const handleLineClick = () => {
    trackLineClick('contact_page');
  };

  const handleMapClick = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'map_click',
        location: 'contact_page',
        timestamp: new Date().toISOString()
      });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-teal-50">
      {/* 右上角導航選單 */}
      <div className="absolute top-8 right-8 flex gap-6 text-sm font-medium z-10">
        <Link 
          to="/"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-home-4-line text-base group-hover:scale-110 transition-transform"></i>
          <span>首頁</span>
        </Link>
        <Link 
          to="/about"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-information-line text-base group-hover:scale-110 transition-transform"></i>
          <span>關於我們</span>
        </Link>
        <Link 
          to="/services"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-service-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務項目</span>
        </Link>
        <Link 
          to="/service-area"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-map-pin-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務範圍</span>
        </Link>
        <Link 
          to="/pricing"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-calculator-line text-base group-hover:scale-110 transition-transform"></i>
          <span>搬家費用</span>
        </Link>
        <Link 
          to="/cases"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-gallery-line text-base group-hover:scale-110 transition-transform"></i>
          <span>成功案例</span>
        </Link>
        <Link 
          to="/knowledge"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-book-open-line text-base group-hover:scale-110 transition-transform"></i>
          <span>搬家知識</span>
        </Link>
        <Link 
          to="/faq"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-question-line text-base group-hover:scale-110 transition-transform"></i>
          <span>常見問題</span>
        </Link>
        <Link 
          to="/contact"
          className="text-teal-600 font-semibold cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-customer-service-line text-base group-hover:scale-110 transition-transform"></i>
          <span>聯絡我們</span>
        </Link>
      </div>

      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 overflow-hidden">
        {/* 動態背景光暈 */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-emerald-400/20 to-transparent rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-teal-400/20 to-transparent rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            {/* 徽章 */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6 border border-white/30">
              <i className="ri-customer-service-2-line text-lg"></i>
              <span>24小時專業客服</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
              聯絡建鈞搬家
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-8">
              專業搬家服務團隊，隨時為您提供協助
            </p>

            {/* 信任指標 */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="text-3xl font-bold text-white mb-1">24/7</div>
                <div className="text-sm text-white/80">全天候服務</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="text-3xl font-bold text-white mb-1">10+</div>
                <div className="text-sm text-white/80">年專業經驗</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="text-3xl font-bold text-white mb-1">5000+</div>
                <div className="text-sm text-white/80">成功案例</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="text-3xl font-bold text-white mb-1">98%</div>
                <div className="text-sm text-white/80">客戶滿意度</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 快速聯繫區塊 */}
      <section className="py-12 -mt-16 relative z-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* 電話聯繫 */}
              <a
                href="tel:0978900081"
                onClick={handlePhoneClick}
                className="group bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-teal-200"
              >
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-phone-line text-2xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm text-gray-600 mb-1">立即來電</div>
                    <div className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">
                      {contactInfo.phone}
                    </div>
                  </div>
                </div>
              </a>

              {/* LINE 聯繫 */}
              <a
                href={contactInfo.line}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLineClick}
                className="group bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-green-200"
              >
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-line-fill text-2xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm text-gray-600 mb-1">LINE 諮詢</div>
                    <div className="text-xl font-bold text-gray-900 group-hover:text-green-600 transition-colors">
                      官方帳號
                    </div>
                  </div>
                </div>
              </a>

              {/* 線上估價 */}
              <Link
                to="/quote"
                className="group bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-emerald-200"
              >
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-calculator-line text-2xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm text-gray-600 mb-1">免費估價</div>
                    <div className="text-xl font-bold text-gray-900 group-hover:text-emerald-600 transition-colors">
                      立即試算
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 聯絡資訊卡片 */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* 左側：聯絡資訊 */}
              <div className="space-y-6">
                <div className="bg-white rounded-3xl shadow-xl p-8">
                  <h2 className="text-3xl font-bold text-slate-800 mb-6 flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center">
                      <i className="ri-information-line text-2xl text-white"></i>
                    </div>
                    聯絡資訊
                  </h2>

                  <div className="space-y-4">
                    {/* 電話 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl hover:shadow-md transition-all duration-300 group">
                      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-phone-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-sm font-semibold text-slate-600 mb-1">24小時服務專線</h3>
                        <a 
                          href={`tel:${contactInfo.phone}`}
                          className="text-lg font-bold text-teal-600 hover:text-teal-700 transition-colors duration-300"
                          onClick={() => trackPhoneClick(contactInfo.phone)}
                        >
                          {contactInfo.phone}
                        </a>
                        <p className="text-sm text-slate-500 mt-1">點擊立即撥打</p>
                      </div>
                    </div>

                    {/* 電子郵件 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-slate-50 to-teal-50 rounded-xl hover:shadow-md transition-all duration-300 group">
                      <div className="w-12 h-12 bg-gradient-to-br from-slate-500 to-slate-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-mail-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-sm font-semibold text-slate-600 mb-1">電子郵件</h3>
                        <a 
                          href={`mailto:${contactInfo.email}`}
                          className="text-base font-bold text-slate-700 hover:text-teal-600 transition-colors duration-300 break-all"
                        >
                          {contactInfo.email}
                        </a>
                        <p className="text-sm text-slate-500 mt-1">線上諮詢</p>
                      </div>
                    </div>

                    {/* 地址 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl hover:shadow-md transition-all duration-300 group">
                      <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-map-pin-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-sm font-semibold text-slate-600 mb-1">公司地址</h3>
                        <a 
                          href={contactInfo.googleMaps}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={handleMapClick}
                          className="text-base font-bold text-slate-700 hover:text-emerald-600 transition-colors duration-300"
                        >
                          {contactInfo.address}
                        </a>
                        <p className="text-sm text-slate-500 mt-1">{contactInfo.plusCode}</p>
                        <p className="text-sm text-teal-600 mt-2 flex items-center gap-1">
                          <i className="ri-navigation-line"></i>
                          點擊開啟 Google 地圖導航
                        </p>
                      </div>
                    </div>

                    {/* 服務時間 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-cyan-50 to-teal-50 rounded-xl hover:shadow-md transition-all duration-300 group">
                      <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-time-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-sm font-semibold text-slate-600 mb-1">服務時間</h3>
                        <p className="text-base font-bold text-slate-700">{contactInfo.hours}</p>
                        <p className="text-sm text-slate-500 mt-1">全年無休</p>
                      </div>
                    </div>

                    {/* 服務範圍 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl hover:shadow-md transition-all duration-300 group">
                      <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-map-2-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-sm font-semibold text-slate-600 mb-1">服務範圍</h3>
                        <p className="text-base font-bold text-slate-700">{contactInfo.serviceArea}</p>
                        <p className="text-sm text-slate-500 mt-1">專業搬家服務</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 右側：服務特色 */}
              <div className="space-y-6">
                <div className="bg-white rounded-3xl shadow-xl p-8">
                  <h2 className="text-3xl font-bold text-slate-800 mb-6 flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center">
                      <i className="ri-star-line text-2xl text-white"></i>
                    </div>
                    為什麼選擇我們
                  </h2>

                  <div className="space-y-4">
                    {/* 專業團隊 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl">
                      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-team-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-bold text-slate-800 mb-1">專業搬運團隊</h3>
                        <p className="text-sm text-slate-600">10年以上經驗，專業訓練，服務貼心</p>
                      </div>
                    </div>

                    {/* 全程保險 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl">
                      <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-shield-check-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-bold text-slate-800 mb-1">全程保險保障</h3>
                        <p className="text-sm text-slate-600">每件物品都有保險，讓您安心無憂</p>
                      </div>
                    </div>

                    {/* 透明收費 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl">
                      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-money-dollar-circle-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-bold text-slate-800 mb-1">透明收費標準</h3>
                        <p className="text-sm text-slate-600">明確報價，無隱藏費用，價格公道</p>
                      </div>
                    </div>

                    {/* 24小時客服 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl">
                      <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-customer-service-2-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-bold text-slate-800 mb-1">24小時客服</h3>
                        <p className="text-sm text-slate-600">全天候服務，隨時提供協助與支援</p>
                      </div>
                    </div>

                    {/* 免費估價 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl">
                      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-calculator-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-bold text-slate-800 mb-1">免費到府估價</h3>
                        <p className="text-sm text-slate-600">專人到府評估，提供最準確的報價</p>
                      </div>
                    </div>

                    {/* 準時服務 */}
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl">
                      <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-time-line text-xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-bold text-slate-800 mb-1">準時準點服務</h3>
                        <p className="text-sm text-slate-600">嚴格遵守時間，絕不延誤您的行程</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google 地圖 */}
      <section className="py-16 bg-gradient-to-br from-slate-100 to-teal-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-slate-800 mb-4 flex items-center justify-center gap-3">
                <i className="ri-map-pin-line text-teal-600"></i>
                我們的位置
              </h2>
              <p className="text-lg text-slate-600">
                歡迎蒞臨參觀，或透過 Google 地圖導航前往
              </p>
            </div>

            <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
              <div className="aspect-video w-full">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.5!2d121.4321!3d25.0311!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a7e3b8b8b8b9%3A0x1234567890abcdef!2z5bu66Yi95pCs5a62!5e0!3m2!1szh-TW!2stw!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="建鈞精緻搬家地圖位置"
                ></iframe>
              </div>
              
              {/* 導航功能區 */}
              <div className="p-6 bg-gradient-to-r from-teal-50 to-emerald-50">
                <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
                  {/* 地址資訊 */}
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
                      <i className="ri-building-2-line text-teal-600"></i>
                      建鈞精緻搬家
                    </h3>
                    <p className="text-slate-600 flex items-center gap-2 mb-1">
                      <i className="ri-map-pin-line text-teal-600"></i>
                      {contactInfo.address}
                    </p>
                    <p className="text-sm text-slate-500 ml-6 mb-3">{contactInfo.plusCode}</p>
                    
                    {/* 複製地址按鈕 */}
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(contactInfo.address);
                        alert('地址已複製到剪貼簿！');
                      }}
                      className="inline-flex items-center gap-1.5 text-sm text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
                    >
                      <i className="ri-file-copy-line"></i>
                      <span>複製地址</span>
                    </button>
                  </div>
                  
                  {/* 導航按鈕組 */}
                  <div className="flex flex-col sm:flex-row gap-3">
                    {/* Google 地圖導航 */}
                    <a
                      href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(contactInfo.address)}&travelmode=driving`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={handleMapClick}
                      className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-xl hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-navigation-line text-xl"></i>
                      <span className="font-semibold">Google 地圖導航</span>
                    </a>
                    
                    {/* Apple 地圖導航 */}
                    <a
                      href={`https://maps.apple.com/?daddr=${encodeURIComponent(contactInfo.address)}&dirflg=d`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={handleMapClick}
                      className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-slate-700 to-slate-800 text-white rounded-xl hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-apple-fill text-xl"></i>
                      <span className="font-semibold">Apple 地圖導航</span>
                    </a>
                  </div>
                </div>
              </div>
              
              {/* 交通資訊 */}
              <div className="p-6 border-t border-slate-100">
                <h4 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                  <i className="ri-route-line text-teal-600"></i>
                  交通方式
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* 開車 */}
                  <div className="flex items-start gap-3 p-4 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl">
                    <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-car-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h5 className="font-semibold text-slate-800 mb-1">自行開車</h5>
                      <p className="text-sm text-slate-600">國道一號泰山交流道下，沿明志路往泰山方向，約5分鐘可達</p>
                    </div>
                  </div>
                  
                  {/* 捷運 */}
                  <div className="flex items-start gap-3 p-4 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl">
                    <div className="w-10 h-10 bg-emerald-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-subway-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h5 className="font-semibold text-slate-800 mb-1">捷運轉乘</h5>
                      <p className="text-sm text-slate-600">搭乘機場捷運至泰山站，轉乘公車或計程車約10分鐘</p>
                    </div>
                  </div>
                  
                  {/* 公車 */}
                  <div className="flex items-start gap-3 p-4 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl">
                    <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-bus-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h5 className="font-semibold text-slate-800 mb-1">公車路線</h5>
                      <p className="text-sm text-slate-600">可搭乘637、638、801路公車至福德街站下車</p>
                    </div>
                  </div>
                </div>
                
                {/* 停車資訊 */}
                <div className="mt-4 p-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-amber-200">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-parking-box-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h5 className="font-semibold text-slate-800 mb-1">停車資訊</h5>
                      <p className="text-sm text-slate-600">公司附近有路邊停車格，或可停放於明志科技大學停車場（步行約5分鐘）</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 常見問題 */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3">
              <i className="ri-question-line text-teal-600"></i>
              常見問題
            </h2>
            <p className="text-lg text-gray-600">
              快速了解搬家相關問題
            </p>
          </div>

          <div className="space-y-4">
            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-teal-200">
              <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-phone-line text-teal-600"></i>
                如何預約搬家服務？
              </h4>
              <p className="text-gray-600">
                您可以透過電話 <a href="tel:0978900081" className="text-teal-600 font-semibold hover:underline">0978-900-081</a>、
                <a href="https://line.me/ti/p/@285yavdh" target="_blank" rel="noopener noreferrer" className="text-teal-600 font-semibold hover:underline">LINE</a> 或
                <Link to="/quote" className="text-teal-600 font-semibold hover:underline">線上估價表單</Link>與我們聯繫，我們會安排專人為您服務。
              </p>
            </div>

            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-emerald-200">
              <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-calendar-line text-emerald-600"></i>
                多久前需要預約？
              </h4>
              <p className="text-gray-600">
                建議至少提前 3-7 天預約，讓我們有充足時間為您安排最適合的搬家時段。旺季（月初、月底）建議提前 1-2 週預約。
              </p>
            </div>

            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-teal-200">
              <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-refresh-line text-teal-600"></i>
                可以臨時取消或改期嗎？
              </h4>
              <p className="text-gray-600">
                如需取消或改期，請提前 24 小時通知我們，我們會盡力配合您的需求。臨時取消可能會產生部分費用。
              </p>
            </div>

            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-emerald-200">
              <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-money-dollar-circle-line text-emerald-600"></i>
                搬家費用如何計算？
              </h4>
              <p className="text-gray-600">
                費用依據搬運距離、物品數量、樓層高度、是否有電梯等因素計算。我們提供
                <Link to="/quote" className="text-emerald-600 font-semibold hover:underline">免費線上估價</Link>，
                也可預約專人到府評估，給您最準確的報價。
              </p>
            </div>

            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-teal-200">
              <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-shield-check-line text-teal-600"></i>
                有提供保險嗎？
              </h4>
              <p className="text-gray-600">
                是的！我們為每次搬家服務都投保了責任險，保障您的物品安全。如有貴重物品，建議事先告知，我們會特別加強保護措施。
              </p>
            </div>

            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-emerald-200">
              <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-box-3-line text-emerald-600"></i>
                有提供紙箱和包裝材料嗎？
              </h4>
              <p className="text-gray-600">
                有的！我們提供專業的包裝材料，包括紙箱、氣泡紙、膠帶等。您也可以選擇自行準備，或向我們購買所需的包裝材料。
              </p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-teal-600 to-emerald-600 text-white rounded-xl hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap font-semibold"
            >
              <i className="ri-question-line text-xl"></i>
              <span>查看更多常見問題</span>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA 區塊 */}
      <section className="py-20 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 relative overflow-hidden">
        {/* 動態背景光暈 */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-emerald-400/20 to-transparent rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-teal-400/20 to-transparent rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          {/* 徽章 */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6 border border-white/30">
            <i className="ri-star-line text-lg"></i>
            <span>專業搬家服務</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            立即聯繫我們
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            10年專業經驗，5000+成功案例，讓我們為您提供最優質的搬家服務
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="tel:0978900081"
              onClick={handlePhoneClick}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-teal-600 rounded-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap font-bold text-lg"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>0978-900-081</span>
            </a>
            <Link
              to="/quote"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/20 backdrop-blur-sm text-white rounded-xl hover:bg-white/30 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap font-bold text-lg border-2 border-white/30"
            >
              <i className="ri-calculator-line text-2xl"></i>
              <span>線上免費估價</span>
            </Link>
          </div>

          {/* 服務保證 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
              <i className="ri-shield-check-line text-3xl text-white mb-2"></i>
              <div className="text-sm text-white/90">全程保險保障</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
              <i className="ri-time-line text-3xl text-white mb-2"></i>
              <div className="text-sm text-white/90">24小時服務</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
              <i className="ri-money-dollar-circle-line text-3xl text-white mb-2"></i>
              <div className="text-sm text-white/90">透明收費</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
              <i className="ri-star-line text-3xl text-white mb-2"></i>
              <div className="text-sm text-white/90">98%滿意度</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
